var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageDefaultBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6554_31988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#E1E4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.625 122.5H165V388.125H345.625V122.5Z",
    stroke: "#C5CBEB",
    strokeWidth: 21.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.125 388.125H372.506",
    stroke: "#C5CBEB",
    strokeWidth: 21.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.898 167.334H207.816V204.416H244.898V167.334Z",
    fill: "#C5CBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.417 167.334H269.336V204.416H306.417V167.334Z",
    fill: "#C5CBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.898 214.296H207.816V251.378H244.898V214.296Z",
    fill: "#C5CBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.417 214.296H269.336V251.378H306.417V214.296Z",
    fill: "#C5CBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.898 265.19H207.816V302.272H244.898V265.19Z",
    fill: "#C5CBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.417 265.19H269.336V302.272H306.417V265.19Z",
    fill: "#C5CBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.125 324.375H271.25V388.125H303.125V324.375Z",
    fill: "#C5CBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.013 357.415C228.06 357.415 232.151 353.324 232.151 348.278C232.151 343.231 228.06 339.14 223.013 339.14C217.967 339.14 213.876 343.231 213.876 348.278C213.876 353.324 217.967 357.415 223.013 357.415Z",
    fill: "#C5CBEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6554_31988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDefaultBuilding);
export default __webpack_public_path__ + "static/media/image-default-building.6d5b1606.svg";
export { ForwardRef as ReactComponent };